/** @format */

import axios from "axios";
import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";

import Tabs from "../../components/Tabs";
import ContentTop from "../../components/ContentTop";
import Chart5 from "../../../../components/Charts/Chart5";
import { header } from "../../../../components/api/Header";
import Table3 from "../../../region/pages/ravotxoji/Table3";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";
import {
  formatDisplayDate,
  getDateColumnsInRange,
  getDefaultRange,
  getMonthsInRange,
  isValidRange,
  normalizeRangeData,
} from "../../../region/pages/ravotxoji/rangeHelpers";

const Ravotxoji = () => {
  const defaultRange = getDefaultRange();
  const [toggle, setToggle] = useState(2);
  const [data, setData] = useState();
  const [rangeData, setRangeData] = useState();
  const [rangeColumns, setRangeColumns] = useState([]);
  const [range, setRange] = useState(defaultRange);
  const [localRange, setLocalRange] = useState(defaultRange);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");

  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [lmonth, setLmonth] = useState(month);
  const tabs = [
    { title: "Oraliq", id: 2, type: "text" },
    { title: "Oylik", id: 1, type: "text" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/ravotxoji/index?month=" +
            month,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan bog'lanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [month]);

  useEffect(() => {
    setMonth(lmonth);
  }, [lmonth]);

  useEffect(() => {
    setSelectedRowKeys("");
  }, [toggle]);

  useEffect(() => {
    if (toggle !== 2) {
      return;
    }

    if (!isValidRange(range)) {
      setRangeColumns([]);
      setRangeData({});
      return;
    }

    const fetchRangeData = async () => {
      setLoading(true);
      const columns = getDateColumnsInRange(range.from, range.to);
      const months = getMonthsInRange(range.from, range.to);

      try {
        const responses = await Promise.all(
          months.map((rangeMonth) =>
            axios.get(
              getEnv('REACT_APP_BASE_URL') +
                "/v1/republik/ravotxoji/index?month=" +
                rangeMonth,
              header()
            )
          )
        );
        const monthlyData = {};
        months.forEach((rangeMonth, index) => {
          monthlyData[rangeMonth] = responses[index]?.data || {};
        });

        setRangeColumns(columns);
        setRangeData(normalizeRangeData(monthlyData, columns));
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan bog'lanishda xato!");
        setRangeColumns(columns);
        setRangeData({});
      } finally {
        setLoading(false);
      }
    };

    fetchRangeData();
  }, [range, toggle]);

  const close = () => {
    setSelectedRowKeys("");
  };

  const applyRange = () => {
    if (!isValidRange(localRange)) {
      alert("Sana oralig'ini to'g'ri kiriting!");
      return;
    }

    setSelectedRowKeys("");
    setRange(localRange);
  };
  const activeData = toggle === 1 ? data : rangeData;

  return (
    <div>
      <ContentTop>
        <ul
          className='content-top-left suv-omborlari'
          style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          {/* TUZATILDI: Sarlavha oylik ko'rsatkich formatida dinamik qilindi */}
          <li style={{ fontWeight: "600", fontSize: "16px" }}>
            Ravotxoji G/U bo'yicha ko'rsatkichlar (m<sup>3</sup>/s)
            <span style={{ color: "#7e8299", fontSize: "13px", marginLeft: "8px", fontWeight: "400" }}>
        {toggle === 1 ? (
          <>({lmonth ? lmonth.split("-").reverse().join(".") : ""} oyi uchun)</>
        ) : (
          <>({formatDisplayDate(range.from)} - {formatDisplayDate(range.to)})</>
        )}
      </span>
          </li>
          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <ul className='content-top-right'>
          {toggle === 1 ? (
            <input
              type='month'
              className='form-control form-control-sm'
              value={lmonth}
              onChange={(e) => setLmonth(e.target.value)}
            />
          ) : (
            <>
              <span className='text-muted small mr-2'>Dan</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.from}
                onChange={(e) =>
                  setLocalRange({ ...localRange, from: e.target.value })
                }
              />
              &nbsp;&nbsp;
              <span className='text-muted small mr-2'>Gacha</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.to}
                onChange={(e) =>
                  setLocalRange({ ...localRange, to: e.target.value })
                }
              />
              &nbsp;&nbsp;&nbsp;
              <button
                className='btn btn-outline-primary btn-sm'
                onClick={applyRange}>
                Ok
              </button>
            </>
          )}
        </ul>
      </ContentTop>

      <div className='tabs-content table-box extra-tab-css'>
        <div className='tabs-content-item active'>
          {loading ? (
            <LoadingCard loading={loading} heightSize='80vh' />
          ) : (
            <div className='table-box-con'>
              <Table3
                data={activeData}
                month={toggle === 1 ? month : range.from.slice(0, 7)}
                dateColumns={toggle === 1 ? undefined : rangeColumns}
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
              />

              {selectedRowKeys > 0 ? (
                <div
                  className='data-content mt-3 mainpage'
                  style={{ position: "relative" }}>
                  <CloseOutlined
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 10,
                      zIndex: 9,
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                    onClick={close}
                  />

                  <Chart5
                    title={"Rovotxoji g/u"}
                    datas={activeData}
                    d2='r'
                    di={selectedRowKeys}
                    color='#7F5AF0'
                  />

                  <Chart5
                    title={"Ziatdin"}
                    datas={activeData}
                    d2='z'
                    di={selectedRowKeys}
                    color='#2CB67D'
                  />
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Ravotxoji;
